import { Box, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const ChangeEmailBox = styled(Box)(({ theme }) => ({
	...flexMixin({ justify: 'flex-start', align: 'flex-start', direction: 'column' }),
	width: '100%',
	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
		gap: 12,
		alignItems: 'flex-start',
	},

	'& > div': {
		width: '100%',
		maxWidth: '100%',
		[theme.breakpoints.down('sm')]: {
			maxWidth: '100%',
			width: '100%',
		},
	},

	'& button': {
		width: '275px',
		padding: '10px 16px',
		borderRadius: '8px',
		border: '1px solid #4786FF',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '157%',
		letterSpacing: '0.1px',
		textTransform: 'none',
		color: '#4786FF',
		boxSizing: 'border-box',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			fontSize: '14px',
			padding: '10px 12px',
		},
		[theme.breakpoints.down('xs')]: {
			fontSize: '14px',
			padding: '8px 12px',
		},

		'&.Mui-disabled': {
			border: '1px solid rgba(0, 0, 0, 0.26)',
		},
	},
}));
